import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Avatar,
  CssBaseline,
} from '@mui/material';
import { Restaurant } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const { user, logout, isAuthenticated, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    logout();
    handleClose();
    navigate('/');
  };

  const handleProfile = () => {
    handleClose();
    navigate('/dashboard');
  };

  return (
    <>
      {/* Ensures body respects AppBar space */}
      <CssBaseline />  

      <AppBar position="fixed" sx={{ backgroundColor: '#000' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={() => navigate('/')}
            sx={{ mr: 2 }}
          >
            <Restaurant />
          </IconButton>

          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            MVE System v2.0
          </Typography>

          {isAuthenticated ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              
                <Button color="inherit" sx={{ mr: 2 }} onClick={() => navigate('/admin/freetimeslot')}>
                Check Table Availability
              </Button>
              <Button color="inherit" sx={{ mr: 2 }} onClick={() => navigate('/book-table')}>
                Book Table
              </Button>
              <Button color="inherit" sx={{ mr: 2 }} onClick={() => navigate('/my-bookings')}>
                Today's Bookings
              </Button>
              {isAdmin && (
                <Button color="inherit" sx={{ mr: 2 }} onClick={() => navigate('/admin')}>
                  Dashboard
                </Button>
              )}

              <IconButton
                size="large"
                onClick={handleMenu}
                color="inherit"
              >
                <Avatar sx={{ width: 32, height: 32, bgcolor: 'secondary.main' }}>
                  {user?.name?.charAt(0)?.toUpperCase()}
                </Avatar>
              </IconButton>

              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <MenuItem onClick={handleProfile}>Profile</MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </Box>
          ) : (
            <Button color="inherit" onClick={() => navigate('/login')}>
              Login
            </Button>
          )}
        </Toolbar>
      </AppBar>

      {/* Spacer to avoid content hiding behind navbar */}
      <Toolbar />
    </>
  );
};

export default Navbar;
